/* unplugin-vue-components disabled */import { render } from "./CompareSVG.vue?vue&type=template&id=7ae6e729"
import script from "./CompareSVG.vue?vue&type=script&lang=js"
export * from "./CompareSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__